module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_8003.f053c4ae.png";